import { EMPTY_ELEMENT } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-element/critical-element.const';
import type { EmptyElement } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-element/critical-element.const';

export interface TabItem {
  label: string;
  value: string;
  isDisabled: boolean;
}

export const getTabItems = (isDisabled: boolean): TabItem[] => [
  { label: 'Details', value: 'details', isDisabled: false },
  { label: 'Monitoring', value: 'monitoring', isDisabled },
  { label: 'Version History', value: 'history', isDisabled },
];

export const getEmptyElement = (year: number): EmptyElement => ({
  ...EMPTY_ELEMENT,
  enteringClassYear: year,
  details: [{ category: '', focusArea: '', subArea: '', options: [] }],
});
